import { StatSegmentRegistry } from '@/types/stats/StatSegmentRegistry.ts';

/** Stany salda wpłat, nazwy jak w wyliczeniu backendu. */
export enum BalanceSegmentKey {
  PAID = 'PAID',
  OVERDUE = 'OVERDUE',
  PLANNED = 'PLANNED',
}

export const BALANCE_SEGMENT_REGISTRY: StatSegmentRegistry = {
  [BalanceSegmentKey.PAID]: { label: 'Zapłacone', tone: 'success' },
  [BalanceSegmentKey.OVERDUE]: { label: 'Po terminie', tone: 'error' },
  [BalanceSegmentKey.PLANNED]: { label: 'Zaplanowane', tone: 'neutral' },
};
